import {
  useActionItemsByClientIdQuery,
} from '../../../shared';
import { ActionItemOutput } from '@coverright/data-access/types/enrollment';

export const useClientNextActions = (clientId?: string): ActionItemOutput[] => {
  const {data} = useActionItemsByClientIdQuery({
    variables: { clientId },
    skip: !clientId
  })

  return data?.actionItemsByClientId || [];
}
